import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Typography } from '@mui/material';

import InputSelect from '../../../ui/Select';
import Page from '../../Page';
import DisputesTable from './DisputesTable';

import { fetchDisputesData } from '../../../modules/disputes/thunks';
import './Disputes.scss';
import { DISPUTES_FILTERS } from './utils';
import { CLEAR_DISPUTES_DATA } from '../../../modules/disputes/reducer';

const Disputes = () => {
  const dispatch = useDispatch();

  const [selectedDispute, setSelectedDispute] = useState(DISPUTES_FILTERS.OPEN_DISPUTES);

  const house = useSelector(store => store.house) || {};

  const houseRef = house.houseRef || '';
  const disputesMenu = [
    {
      label: 'Open disputes',
      value: DISPUTES_FILTERS.OPEN_DISPUTES
    },
    {
      label: 'Past disputes within 6 months',
      value: DISPUTES_FILTERS.PAST_SIX_MONTHS
    },
    {
      label: 'Past disputes within this year',
      value: DISPUTES_FILTERS.PAST_YEAR
    },
    {
      label: 'All disputes',
      value: DISPUTES_FILTERS.ALL_DISPUTES
    }
  ];

  const changeFilterHandler = value => {
    dispatch(fetchDisputesData(value, houseRef));
    setSelectedDispute(value);
  };

  useEffect(() => {
    if (houseRef) dispatch(fetchDisputesData(selectedDispute, houseRef));

    return () => {
      dispatch({
        type: CLEAR_DISPUTES_DATA
      });
    };
  }, [dispatch, houseRef]);

  return (
    <Page header={{ title: 'View Disputes' }}>
      <Container disableGutters maxWidth={false}>
        <Typography variant="subtitle1" gutterBottom paragraph>
          Manage disputes by clicking on the "Dispute Status" link, or by using the options at the
          bottom of the screen to send messages, close or cancel. Disputes must be open for 4 days
          before they can be closed.{' '}
          <a
            href="https://www.invaluableauctions.com/inv/help-center/resource/disputes/"
            target="_blank"
            rel="noreferrer"
          >
            Learn more about managing disputes and returns »
          </a>
        </Typography>
        <InputSelect
          defaultValue={selectedDispute}
          sx={{ width: 250 }}
          placeholder="Please select an option"
          label="Filter By"
          onChange={changeFilterHandler}
          size="small"
          menus={disputesMenu}
        />
        <DisputesTable selectedDispute={selectedDispute} />
      </Container>
    </Page>
  );
};

export default Disputes;
